const ListHeader = [{
    name: 'id',
    value: 'filters.id',
    sortable: true,
    width: 148,
}, {
    name: 'name',
    value: 'filters.name',
    sortable: true,
    width: 200,
}, {
    name: 'type',
    value: 'filters.filter_feature',
    sortable: true,
    width: 150,
}, {
    name: 'pin',
    value: 'filters.filter_pinned',
    sortable: true,
    width: 100,
}, {
    name: 'result',
    value: 'filters.result',
    sortable: false,
    width: 85,
}, {
    name: 'update_time',
    value: 'filters.update_time',
    sortable: true,
    width: 120,
}];

export default  ListHeader;
